/* global gtag_ks_tracking */
$('.send-with-whatsapp').on('submit', function (e) {
    e.preventDefault();

    var el_parts = $(this).find('.text-part'),
        el_text = $(this).find('[name=text]');

    $.each(el_parts, function (key, val) {
        el_text.val(el_text.val() + (key === 1 ? '\n' : '') + $(val).val())
    });

    if(typeof gtag_ks_tracking !== "undefined"){

        gtag_ks_tracking('event', 'WhatsApp Bilgi Al', {
            event_category: location.origin,
            event_label: location.pathname
        });

    }

    $(this).off('submit').submit();
});
